/*
 * FOR SALE — page d'une annonce (/pages/listings/<handle>, section fs-listing-page) et pages d'information (Avis, section
 * fs-reviews-page ; Fonctionnement et FAQ, sections fs-info-how et fs-info-faq). La vitrine (for-sale.js) n'y est pas
 * chargée : ce script pose le menu repliable de l'en-tête (téléphone), comme sur l'accueil, et, sur la page d'une
 * annonce, le retour à la liste : « ← Annonces <jeu> » ([data-fs-ld-back]) reprend l'adresse de la liste d'où l'on
 * vient (vue, filtres, tri et recherche gardés ; « Tous les jeux » : « ← Toutes les annonces »), sinon la liste du jeu.
 * La fiche (fs-listing-detail.js), le compte (fs-account.js) et le ticket (fs-ticket.js) s'activent seuls.
 */
(() => {
  /* Retour à la liste : seulement depuis la liste de ce site (jamais une adresse extérieure). La provenance perd
     &compare= (face-à-face) et &listing= (ancien lien de fiche : l'accueil renverrait aussitôt vers cette page). */
  const back = document.querySelector('[data-fs-listing-page] [data-fs-ld-back]');
  if (back && document.referrer) {
    try {
      const from = new URL(document.referrer);
      const list = new URL(back.getAttribute('href'), window.location.href);
      if (from.origin === window.location.origin && from.pathname === list.pathname) {
        from.searchParams.delete('compare'); from.searchParams.delete('comparer');
        if (!from.searchParams.has('game') && from.searchParams.has('univers')) from.searchParams.set('game', from.searchParams.get('univers'));
        from.searchParams.delete('univers');
        if (!from.searchParams.has('sort') && from.searchParams.has('tri')) from.searchParams.set('sort', from.searchParams.get('tri'));
        from.searchParams.delete('tri');
        const priceSort = { 'prix-asc': 'price-asc', 'prix-desc': 'price-desc' }[from.searchParams.get('sort')];
        if (priceSort) from.searchParams.set('sort', priceSort);
        from.searchParams.delete('listing'); from.searchParams.delete('annonce');
        from.hash = 'fs-catalog';
        back.setAttribute('href', from.pathname + from.search + from.hash);
        const game = from.searchParams.get('game') || '';
        const label = back.querySelector('span:not([aria-hidden])');
        const { t } = window.fsI18n;
        if (label && game !== back.dataset.fsLdBack) label.textContent = t(game ? 'listing.detail.back_list' : 'listing.detail.back_all');
      }
    } catch { /* adresse de provenance illisible : lien de la liste du jeu */ }
  }

  const root = document.querySelector('[data-fs-listing-page], [data-fs-reviews-page], [data-fs-info-page]');
  if (!root || root.dataset.fsInteractive) return;
  const header = root.querySelector('[data-fs-site-header]');
  const toggle = header?.querySelector('[data-fs-menu-toggle]');
  const menu = header?.querySelector('[data-fs-site-nav]');
  if (!header || !toggle || !menu) return;
  const close = (focusToggle = false) => {
    if (toggle.getAttribute('aria-expanded') !== 'true') return;
    toggle.setAttribute('aria-expanded', 'false');
    header.removeAttribute('data-fs-menu-open');
    if (focusToggle) toggle.focus();
  };
  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open));
    header.toggleAttribute('data-fs-menu-open', open);
    /* La navigation précède « Menu » dans le DOM (ordre visuel de l'en-tête) : le focus va à son premier lien. */
    if (open) menu.querySelector('a')?.focus();
  });
  menu.addEventListener('click', (event) => { if (event.target.closest('a')) close(); });
  header.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(true); });
  document.addEventListener('click', (event) => { if (!header.contains(event.target)) close(); });
  root.dataset.fsInteractive = 'true';
})();
